/* eslint-disable */
import React from 'react'
import {Pagination} from 'antd'
import jMoment from 'moment-jalaali'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {divIcon} from 'leaflet'
import {renderToStaticMarkup} from 'react-dom/server'
import {Map, Marker, TileLayer, Popup, Polyline} from 'react-leaflet'
import TimeDisplay from '../../BaseComponent/timeDisplay'
import {Link} from 'react-router-dom'
import Sort from '../../Pagination/Sort'

export default class ReportLocation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      pageSize: 50,
      pageNumber: 1,
      address: {},
      modal: false,
      sortData: [
        {
          name: 'ردیف',
          value: 'index',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'راننده',
          value: 'driverId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شیفت زمانی',
          value: 'driverId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ تحویل',
          value: 'deliveryTime',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تحویل',
          value: 'driverId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'شناسه فاکتور',
          value: 'invoiceId',
          sorted: false,
          direction: null,
          sortable: false
        },
        // {
        //   name: "شماره فاکتور",
        //   value: "invoiceNum",
        //   sorted: false,
        //   direction: null,
        //   sortable: false,
        // },
        {
          name: 'خریدار',
          value: 'buyerName',
          sorted: false,
          direction: null,
          sortable: false
        },
        // {
        //   name: "تحویل گیرنده",
        //   value: "driverId",
        //   sorted: false,
        //   direction: null,
        //   sortable: false,
        // },
        // {
        //   name: "موبایل",
        //   value: "driverId",
        //   sorted: false,
        //   direction: null,
        //   sortable: false,
        // },
        {
          name: 'آدرس',
          value: 'address',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وضعیت تحویل',
          value: 'driverId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'موقعیت',
          value: 'driverId',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      sortBy: ''
    }
  }

  showAddress = (latitude, longitude, recipientName, customerLatitude, customerLongitude, address) => {
    this.setState({
      latitude,
      longitude,
      recipientName,
      customerLatitude,
      customerLongitude,
      address,
      modal: true
    })
  }

  getMarkers = () => {
    const positions = this.props.value
    var pos = []
    console.log(positions)
    positions.forEach((item) => {
      const obj = {
        lat: item.latitude,
        lng: item.longitude,
        dispatchDate: item.dispatchDate,
        driverName: item.driver ? item.driver.name : ''
      }
      pos.push(obj)
    })
    let points = pos
    console.log(points)
    const array = []
    points.forEach((item) => {
      if (item.lat && item.lng) {
        array.push({
          location: [item.lat, item.lng],
          ...item
        })
      }
    })
    return array
  }

  loadTableData = (pageNumber) => {
    const v = this.props.value.map((item) => ({...item}))
    console.log(v)
    return v.slice((pageNumber - 1) * this.state.pageSize, pageNumber * this.state.pageSize)
  }

  componentDidMount() {
    this.changePage(1)
  }

  changePage = (pageNumber) => {
    this.setState(
      {
        pageNumber
      },
      () => {
        this.loadTableData(pageNumber)
      }
    )
  }

  getSort = (sortBy) => {
    this.setState(
      {
        sortBy
      },
      () => {
        this.props.refreshReport({sortBy, export: true})
      }
    )
  }

  render() {
    const {value} = this.props
    const unSelected = renderToStaticMarkup(<img src={require('../../../image/requestPack.png')} />)
    const selected = renderToStaticMarkup(<img src={require('../../../image/finishPack.png')} />)
    return (
      <div>
        {this.loadTableData(this.state.pageNumber).length ? (
          <div>
            <div className="addressMap">
              <Map center={[35.6892, 51.389]} zoom={10} style={{height: '500px'}}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                {this.getMarkers().map((item, index) => (
                  <Marker position={item.location}>
                    <Popup>
                      <div className="text-center">{item.driverName}</div>
                      <div className="text-center">
                        {item.dispatchDate && jMoment(item.dispatchDate).format('jYYYY/jMM/jDD HH:mm')}
                      </div>
                    </Popup>
                  </Marker>
                ))}
                <Polyline positions={this.getMarkers()} />
              </Map>
            </div>
            <table className="baseTable">
              <Sort data={this.state.sortData} getSort={this.getSort} />
              <tbody>
                {/* <tr className="firstRow">
                  <td>راننده</td>
                  <td>شیفت زمانی</td>
                  <td>تاریخ تحویل</td>
                  <td>تحویل </td>
                  <td>شناسه فاکتور</td>
                  <td>شماره فاکتور</td>
                  <td> خریدار</td>
                  <td> تحویل گیرنده</td>
                  <td>موبایل</td>
                  <td>وضعیت تحویل</td>
                  <td>موقعیت</td>
                </tr> */}
                {this.loadTableData(this.state.pageNumber).map((list, index) => (
                  <tr
                    key={index}
                    style={
                      list.supplyOrderQuantity !== list.cardexQuantity || list.deliveryQuantity !== list.detailQuantity
                        ? {backgroundColor: '#fdcccc'}
                        : {}
                    }
                  >
                    <td>{(this.state.pageNumber - 1) * 50 + index + 1}</td>
                    <td>{list.driver.name}</td>
                    <td>
                      <TimeDisplay value={list} label=" تا " />
                    </td>
                    <td>{jMoment(list.dispatchDate).format('jYY/jM/jD HH:mm')}</td>
                    <td>{list.deliveredBetween ? 'بازه' : 'خارج از بازه'}</td>
                    <td>
                      <Link
                        to={{
                          pathname: '/baskets',
                          search: `?invoiceId=${list.invoice.invoiceId}`
                        }}
                        target={'_blank'}
                      >
                        {list.invoice.invoiceId}
                      </Link>
                    </td>
                    {/* <td>{list.invoice.invoiceNum}</td> */}
                    <td>{list.invoice.buyerName}</td>
                    {/* <td>{list.invoice.recipientName}</td> */}
                    <td>{list.invoice.address}</td>
                    {/* <td>
                        {list.invoice.mobile == null
                          ? "-"
                          : list.invoice.mobile.replace(/\+98/g, "0")}
                      </td> */}
                    <td>{!list.locationIncompatible ? 'تحویل در مکان مورد نظر' : 'عدم تحویل در مکان مورد نظر'}</td>
                    <td>
                      <button
                        onClick={() =>
                          this.showAddress(
                            list.latitude,
                            list.longitude,
                            list.invoice.recipientName,
                            list.invoice.latitude,
                            list.invoice.longitude,
                            list.invoice.address
                          )
                        }
                      >
                        <img src={require('../../../image/loc.svg')} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="paginationWrapp">
              <Pagination
                current={this.state.pageNumber}
                onChange={this.changePage}
                pageSize={this.state.pageSize}
                total={this.props.total}
              />
            </div>
          </div>
        ) : null}

        <Modal isOpen={this.state.modal} toggle={() => this.setState({modal: false})} size="lg">
          <ModalHeader toggle={() => this.setState({modal: false})}>
            <p>موقعیت تحویل سفارش برای : {this.state.recipientName}</p>
            <p>
              موقعیت ثبت شده در فاکتور :{' '}
              {this.state.customerLatitude === null || this.state.customerLatitude === 0 ? (
                'موقعیتی ثبت نشده است'
              ) : (
                <img src={require('../../../image/requestPack.png')} />
              )}
            </p>
            <p>آدرس ثبت شده در فاکتور : {this.state.address}</p>
            <p>
              موقعیت تحویل شده : <img src={require('../../../image/finishPack.png')} />
            </p>
          </ModalHeader>
          <ModalBody>
            <div className="bg-white">
              <Map center={[35.6892, 51.389]} zoom={10} style={{height: '500px'}}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                {this.state.latitude && this.state.longitude && (
                  <Marker
                    position={[this.state.latitude, this.state.longitude]}
                    title={this.state.recipientName}
                    icon={divIcon({
                      html: selected,
                      iconSize: [30, 30],
                      iconAnchor: [10, 38]
                    })}
                  />
                )}

                {this.state.customerLatitude && this.state.customerLongitude && (
                  <Marker
                    position={[this.state.customerLatitude, this.state.customerLongitude]}
                    title="موقعیت ثبت شده توسط رساننده"
                    icon={divIcon({
                      html: unSelected,
                      iconSize: [30, 30],
                      iconAnchor: [10, 38]
                    })}
                  />
                )}
              </Map>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({modal: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
